import Vue from 'vue';
import dayjs from 'dayjs';
import Popper from 'vue-popperjs';
import { BfButton } from 'components/Butterfly';
import Dropdown from "components/Butterfly/Dropdown/Dropdown.vue";
import DateRangePicker from 'components/widgets/DateRangePicker/DateRangePicker.vue';
import { DateRangeTypeEnum } from 'types/DashboardTypes';
import Icon from 'components/Icon.vue';
import DropdownItem from 'components/Butterfly/Dropdown/DropdownItem.vue';
import ToggleSliderInput from 'src/components/forms/ToggleSliderInput.vue';
export default Vue.extend({
    components: {
        BfButton,
        Dropdown,
        Popper,
        DateRangePicker,
        Icon,
        DropdownItem,
        ToggleSliderInput,
    },
    props: {
        dashboards: { type: Array, default: () => [] },
        dashboardId: { type: Number, required: true },
        dashboardName: { type: String, required: false, default: '' },
        dateFields: { type: Array, default: () => [] },
        defaultDateField: { type: String, required: false, default: null },
        weekStart: { type: String, required: false, default: 'Sunday' },
        isLoading: { type: Boolean, default: true },
        viewerMode: { type: Boolean, default: false },
        dashboardDateRange: { type: Object, required: false, default: null },
        featureFlags: { type: Object, default: () => ({}) },
        schema: { type: Array, default: () => ([]) },
        groupBy: { type: String, required: false, default: null },
        compareMode: { type: Boolean, required: false, default: false },
        dashboardType: { type: String, required: true },
    },
    data() {
        return {
            maxNameLength: 50,
        };
    },
    computed: {
        categoricalFields() {
            return this.schema.filter((field) => field.typename === 'LABEL');
        },
        dateLabel() {
            if (this.dashboardDateRange?.type === DateRangeTypeEnum.CUSTOM) {
                const from = this.dashboardDateRange?.dateFrom || 'All time';
                const to = this.dashboardDateRange?.dateTo || 'All time';
                if ((from === to) && from === 'All time')
                    return 'All time';
                return `${from} - ${to}`;
            }
            if (this.weekStart == 'Monday') {
                dayjs.Ls.en.weekStart = 1;
            }
            else if (this.weekStart == 'Sunday') {
                dayjs.Ls.en.weekStart = 0;
            }
            return this.dashboardDateRange?.type ?? '';
        },
        hasDates() {
            return this.dateFields.length > 0;
        },
        canDeleteDashboard() {
            return this.dashboards.length > 1;
        },
        sortedDashboards() {
            return [...this.dashboards]
                // sort alphabetically (taking into account numbers may be in the string)
                .sort((a, b) => `${a.name || ''}`.localeCompare(`${b.name || ''}`, undefined, { numeric: true }));
        },
        currentDashboard() {
            return this.dashboardId && this.dashboards.find(({ id }) => id === this.dashboardId);
        },
    },
    methods: {
        truncate(str, len) {
            const suffix = str.length > len ? '...' : '';
            return str.slice(0, len) + suffix;
        },
        showWidgetModal() {
            this.$emit('show-widget-modal');
        },
        showDigestModal() {
            this.$emit('show-digest-modal');
        },
        showShareModal() {
            this.$emit('show-share-modal');
        },
        exportCsv() {
            this.$emit("export-to-csv");
        },
        exportPpt() {
            this.$emit("export-to-ppt");
        },
        showQueriesModal() {
            this.$emit('show-queries-modal');
        },
        deleteDashboard() {
            this.$emit('show-delete-dashboard-modal');
        },
        setDateFilters(dateField, from, to, type) {
            this.$emit('updated-date-range', type, dateField, to, from);
        },
        selectGroupby(value) {
            this.$emit('groupby-changed', value);
        }
    }
});
